import React from 'react';
import { FileTextIcon, CpuIcon, FileCheck2Icon, ArrowRightIcon } from 'lucide-react';
const nodes = [{
  icon: FileTextIcon,
  label: 'Prompt',
  sub: 'Your instruction',
  tone: 'bg-white text-plum border-grape/20',
  iconTone: 'bg-lilac-soft text-grape'
}, {
  icon: CpuIcon,
  label: 'AI',
  sub: 'ChatGPT · Claude · Gemini · Other',
  tone: 'bg-plum text-white border-plum',
  iconTone: 'bg-grape text-white'
}, {
  icon: FileCheck2Icon,
  label: 'Result',
  sub: 'A structured engineering draft',
  tone: 'bg-white text-plum border-grape/30',
  iconTone: 'bg-blush-soft text-blush'
}];
export function PromptFlow() {
  return <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center" aria-label="How a prompt works" data-id="element-245" data-mp="2zl0mlxdnd759">
      {nodes.map((n, i) => <React.Fragment key={n.label} data-id="element-246" data-mp="1567qlx8uqecs" data-mpi={i}>
          <div className={`flex items-center gap-3 rounded-2xl border px-4 py-3 sm:w-60 ${n.tone}`} data-id="element-247" data-mp="1579betfo6f7p">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${n.iconTone}`} data-id="element-248" data-mp="1a5knzbxcn3tm">
              <n.icon className="h-5 w-5" data-id="element-249" data-mp="1f11iin0nt0er" />
            </span>
            <div className="min-w-0" data-id="element-250" data-mp="1a8qh1fq9t6k3">
              <p className="font-display text-base font-black" data-id="element-251" data-mp="1a7p8bhwq8w5j">{n.label}</p>
              <p className="truncate text-xs opacity-70" data-id="element-252" data-mp="15ap0p2k8blcb">{n.sub}</p>
            </div>
          </div>
          {i < nodes.length - 1 && <ArrowRightIcon className="mx-auto h-5 w-5 rotate-90 text-grape sm:mx-0 sm:rotate-0" aria-hidden="true" data-id="element-253" data-mp="108zmje1pmrk0" />}
        </React.Fragment>)}
    </div>;
}